import React from 'react';
import useAccessRights from 'packages/hooks/useAccessRights';
import { ActiveSplits } from 'packages/store/user/types';
import ColorInputLegacy from './ColorInputLegacy';
import ColorInputV2 from './ColorInputV2';
import type { Props } from './shared';

const ColorInput = (props: Props) => {
    const { isSplitEnabled } = useAccessRights();
    const isDsColorPickerEnabled = isSplitEnabled(ActiveSplits.studioDsColorPicker);

    return isDsColorPickerEnabled ? <ColorInputV2 {...props} /> : <ColorInputLegacy {...props} />;
};

export default ColorInput;
